export const ID_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_inven-track-15/artifacts/bwzqyq4d_ID%20Logo.webp";
export const C_LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_inven-track-15/artifacts/wijty053_C%20logo.webp";

// dark=true renders the "C" mark + white wordmark for the navy sidebar.
// dark=false renders the full IntenCiv Diagnostics logo (for white surfaces).
export const Logo = ({ dark = false, size = "md" }) => {
  if (dark) {
    const dim = size === "lg" ? "h-11 w-11" : "h-9 w-9";
    const text = size === "lg" ? "text-3xl" : "text-2xl";
    return (
      <div className="flex items-center gap-2.5" data-testid="app-logo">
        <img src={C_LOGO} alt="IntenCiv" className={`${dim} object-contain shrink-0`} />
        <div className="leading-none">
          <span className={`font-serif ${text} tracking-tight text-white`}>IntenCiv</span>
          <div className="text-[10px] font-medium tracking-widest uppercase text-white/60">Diagnostics</div>
        </div>
      </div>
    );
  }
  const h = size === "lg" ? "h-16" : "h-10";
  return (
    <img src={ID_LOGO} alt="IntenCiv Diagnostics" className={`${h} object-contain`} data-testid="app-logo" />
  );
};
